import React from 'react';
import ReactAsyncSelect from 'react-select/async';
import cx from 'classnames';

import useCustomSelectTheme from '../../hooks/useCustomSelectTheme';
import { debouncePromise } from '../../../../../utils/debounce-promise';
import { useInnerValue } from '../../../articles/hooks/useInnerValue';
import styles from './AsyncSelect.module.scss';

const LOAD_OPTIONS_DEBOUNCE_DELAY = 300;

interface IAsyncSelectProps extends React.ComponentPropsWithoutRef<ReactAsyncSelect> {
  isBorderless?: boolean;
  disabledDebounce?: boolean;
}

const AsyncSelect = React.forwardRef<any, IAsyncSelectProps>(function AsyncSelect(
  {
    inputValue,
    onInputChange,
    isBorderless = false,
    disabledDebounce = false,
    className,
    loadOptions,
    ...restProps
  },
  ref
): JSX.Element {
  const getCustomTheme = useCustomSelectTheme();
  const { innerValue: innerInputValue, handleChange: handleInputValueChange } = useInnerValue(
    inputValue,
    onInputChange
  );
  const enhancedLoadOptions = disabledDebounce
    ? loadOptions
    : debouncePromise(loadOptions, LOAD_OPTIONS_DEBOUNCE_DELAY); // FYI: we can't use lodash debounce here because of https://github.com/JedWatson/react-select/issues/3075

  return (
    <ReactAsyncSelect
      {...restProps}
      ref={ref}
      loadOptions={enhancedLoadOptions}
      className={cx(
        styles.asyncReactSelectContainer,
        { [styles.asyncReactSelectContainerBorderless]: isBorderless },
        className
      )}
      classNamePrefix="asyncReactSelect"
      theme={getCustomTheme}
      inputValue={innerInputValue}
      menuIsOpen={!!innerInputValue}
      onInputChange={handleInputValueChange}
    />
  );
});

export default AsyncSelect;
